import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    type : 'component',
    columnId : null,
    componentId : null,
    componentStyle : null,
    componentType : null,
    component : null
}

export const copySlice = createSlice({
  name: 'copyPaste',
  initialState,
  reducers: {
      setCopyComponent: (state, action) => {
        const component = JSON.stringify(action.payload);
        const componentStyle = JSON.stringify(action.payload.style); 
        state.componentId = action.payload.id;
        state.component = component;
        state.componentStyle = componentStyle;
        state.componentType = action.payload.type;
      },
  },
})

// Action creators are generated for each case reducer function
export const { setCopyComponent } = copySlice.actions

export default copySlice.reducer